import React, { FC, useEffect, useState, useMemo } from "react";
import { Button, Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailsModel";
import { ColumnsType } from "antd/es/table";
import { ITopType } from "@/types/ScmTypes";
import { DetailType } from "@/types/ScmEnums";
import { IDetailList } from "../../purchaseRoType";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { IVRMshelfDetail } from "@/views/base/warehouse/warehouseTypes";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { formatNum, formatIntPoint } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhBut } from "@/components/YhButton";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";

export const TableBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const {
        setAddModalVisible,
        detailAddList,
        detailDataSource,
        detailLookList,
        shelfAllList,
        detailEditForm,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        setShelfAllList,
        setDetaiAddDataRow,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setDetailAddList,
        setDetailDataSource,
        detailDetailList,
        setTopButsControl,
        setHistoryVisible,
        setHistoryRow,
        warehouseData, setWarehouseData
    } = usePurchaseRoDetailsModel();
    const onHistoryModel = (record: IDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const switchModelViaible = () => {
        IFormRef.current?.validateFields().then(async res => {
            setAddModalVisible(true)
        })
    }
    const controlEditable = () => {
        if (mode === DetailType.look) return false
        if (mode === DetailType.edit &&
            detailEditForm.status === DictCodeEnmu.PURCHASE_RETURN_STATUS_SETTLE ||
            detailEditForm.status === DictCodeEnmu.PURCHASE_RETURN_STATUS_STOCK_IO || detailEditForm.status === "purchase-return.paying") {
            return false
        }
        return true
    }
    const action = <>
        {controlEditable() && <>
            <YhAuth resCode={ResourceAuthEnum.P_R_ED_ADD_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => switchModelViaible()}
                >新增配件</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_R_ED_DEL_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => { detailDetailList(mode) }}
                >批量删除</Button>
            </YhAuth>
        </>}
    </>
    const wsChanges = async (value: string, option: ISelectOption, record: IDetailList) => {
        let params = {
            pageSize: 10000,
            pageNum: 1,
            warehouseCode: value,
        }
        const { retData } = await warehouseService.shelfAllPage(params)
        const newRecords = retData.map((item: IVRMshelfDetail) => { return { ...item, name: item.code } })
        setShelfAllList(newRecords)
    }
    const defaultColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '配件编码',
            width: 120,
            dataIndex: 'materialCode',
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
            render: (text: any, record: any, index: number) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '采购数量',
            width: 100,
            dataIndex: 'purchaseNum',
        }, {
            title: '采购单价',
            width: 100,
            dataIndex: 'purchasePrice',
        }, {
            title: '退货数量',
            width: 100,
            dataIndex: 'num',
            editable: controlEditable()
        }, {
            title: '退货单价',
            width: 100,
            dataIndex: 'price',
            editable: controlEditable()
        }, {
            title: '退货金额',
            width: 100,
            dataIndex: 'amount',
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '已退货数量',
            width: 100,
            dataIndex: 'preturnNum',
        }, {
            title: '可用库存数量',
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            title: '仓库',
            width: 260,
            dataIndex: 'warehouseCode',
            editType: "select",
            onSelectChange: wsChanges,
            options: transOptions(warehouseData[mode]),
            rules: [{ required: true, message: "请选择仓库" }],
            render: (text: string) => transOptions(warehouseData[mode]).find(item => item.value === text)?.label ?? "请选择仓库",
        }, {
            title: '货位',
            width: 160,
            dataIndex: 'shelfCode',
            editType: "select",
            rules: [{ required: true, message: "请选择货位" }],
            options: transOptions(shelfAllList),
            render: (text: string) => text ?? "请选择货位",
        }, {
            title: '备注',
            width: 300,
            dataIndex: 'note',
            editable: mode != "look" ? true : false,
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                controlEditable() && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                />
        }
    ];

    const removeMaterial = (record: IDetailList) => {
        detailDetailList(mode, record)
    }

    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,
    }
    const newSelectColumns = () =>
        defaultColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchaseReturn", "roleCodes": roles };
        return getRoleColumns("purchaseReturn", "明细", newSelectColumns(), params);
    }, [roles, typeList[mode], defaultColumns]);
    const handleSave = (row: IDetailList) => {
        let { num, price, amount, warehouseCode, shelfCode, preturnNum, purchaseNum, inventoryNum } = row
        console.log(inventoryNum)
        preturnNum = +formatNum(preturnNum)
        purchaseNum = +formatNum(purchaseNum)
        price = +formatNum(price)
        num = +formatIntPoint(num, inventoryNum, "退货数量>=可用库存数量")

        let newRow = {
            ...row,
            warehouseName: getFindItem(warehouseCode as string, warehouseData[mode])?.name,
            shelfId: getFindItem(shelfCode as string, shelfAllList)?.id ?? row.shelfId,
            num,
            amount: +formatNum(num * price),
            // confirmNum,
            // damageNum,
        }
        let newData = mode === "edit" ? detailDataSource : detailAddList;
        const index = newData.findIndex((item) => item.id ? row.id === item.id : row.detailsId === item.detailsId);
        const item = newData[index];

        //判断仓库变化时，  重置货位
        if (newRow.warehouseCode !== newData[index].warehouseCode) {
            newRow.shelfCode = undefined
        }
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        setTopButsControl(true)
    }

    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title="配件信息" rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.detailsId as string}
                rowSelection={
                    mode === DetailType.look ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={typeList[mode]}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{ x: 'max-content', y: mode === DetailType.add ? 'calc(100vh - 640px)' : 'calc(100vh - 530px)' }}
            />
        </YhBox>
    )
}